<template>
  <HeaderLayout
    v-if="settingStore.showHeader"
    :theme="settingStore.displayMode"
    :layout="settingStore.layout"
    :is-fixed="settingStore.isHeaderFixed"
    :is-compact="settingStore.isSidebarCompact"
  />
</template>

<script setup lang="ts">
import { useSettingStore } from '@/store';

import HeaderLayout from './HeaderLayout.vue';

// const permissionStore = usePermissionStore();
const settingStore = useSettingStore();
// const { routers } = storeToRefs(permissionStore);
// const headerMenu = computed(() => {
//   if (settingStore.layout === 'mix') {
//     if (settingStore.splitMenu) {
//       return routers.value.map((menu) => ({
//         ...menu,
//         children: [],
//       }));
//     }
//     return [];
//   }
//   return routers.value;
// });
</script>
